import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { AddNewDocFeedback } from '../../../../../pages/user-page/pages/docs/componenets/add-new-doc-feedback';
import { FileUploadFile } from 'primereact/fileupload';
import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import { uploadDocFileAndRetrieveUrlOperation } from '../../../../../pages/user-page/pages/docs/componenets/operations/upload-doc-file-and-retrieve-url-operation';

interface AddFeedbackDialogProps {
  visible: boolean;
  onHide: () => void;
  userId: number;
  docId: number;
  onFeedbackAdded: () => void;
}

export const AddFeedbackDialog: React.FC<AddFeedbackDialogProps> = ({
  visible,
  onHide,
  userId,
  docId,
  onFeedbackAdded,
}) => {
  const [loading, setLoading] = useState(false);

  const handleFeedbackSubmit = async (
    userId: number,
    docId: number,
    value: string,
    file?: FileUploadFile,
  ) => {
    try {
      if (value.length < 3) {
        toast.warn('על התגובה להיות בעלת שלוש תווים לפחות');
        return;
      }
      setLoading(true);

      let fileUrl;
      if (file) {
        fileUrl = await uploadDocFileAndRetrieveUrlOperation(file, userId);
      }

      await appApi.addDocFeedback(userId, docId, value, fileUrl);
      toast.success('הוספת התגובה התבצעה בהצלחה');

      // Refresh the user profile data
      await appApi.getHome2();
      setLoading(false);

      onFeedbackAdded();
    } catch (e) {
      setLoading(false);
      toast.error('הפעולה נכשלה, נסה שוב בעוד מספר רגעים');
      console.error(`handleFeedbackSubmit is failed with the error: ${e}`);
    }
  };

  return (
    <Dialog
      header="הוסף משוב למסמך"
      visible={visible}
      onHide={onHide}
      style={{ width: '500px' }}
    >
      <AddNewDocFeedback
        userId={userId}
        docId={docId}
        onFeedbackSubmit={handleFeedbackSubmit}
        isLoading={loading}
      />
    </Dialog>
  );
};
